import './AutoMessageAdd.scss'
import React from 'react'
import { channelStore } from '../../app/stores'
import autoMessageIllustration from '../../assets/auto-messages.svg'
import { BlankSlate, Button, Icon } from '../../lib'

const AutoMessageAdd = ({ onAdd }) => {
  if (channelStore.autoMessages.length > 0) {
    return (
      <Button className='AutoMessageAdd' styleType='empty' onClick={onAdd}>
        <Icon name='plus' /> New auto message
      </Button>
    )
  } else {
    return (
      <BlankSlate
        img={autoMessageIllustration}
        title='Send messages to your visitors'
        body='Setup automatic messages that send based on time, location, or pageviews'
        action='Create a new auto message'
        onAction={onAdd}
      />
    )
  }
}

AutoMessageAdd.displayName = 'AutoMessageAdd'

export default AutoMessageAdd



// WEBPACK FOOTER //
// ./src/channel/automessages/AutoMessageAdd.js